export default "__VITE_ASSET__BYcW4Y_3__"